<template>
  <div style="text-align: center">
    <van-nav-bar
      id="reset"
      title="既往病史"
      left-text="上一步"
      right-text="检测须知"
      left-arrow
      @click-left="goback"
      @click-right="onClickRight"
    />
    <van-row>
      <van-col span="8" offset="8">
        <h3>填写既往病史</h3>
      </van-col>
      <van-col span="8">
        <van-button round type="primary"  size="small" style="margin-top:16px;width:80px" @click="skip">跳过</van-button>
      </van-col>
    </van-row>
    <div></div>
    <van-form input-align="right" >
      <van-field name="switch" label="高血压">
        <template #input
          ><van-switch
            v-model="form.highBloodPressure"
            size="20"
            active-value="是"
            inactive-value="否"
            @change="highBloodPressureChange"
        /></template>
      </van-field>
      <!-- <template #input></template> -->
      <van-field
        :disabled="form.highBloodPressure=='否'"
        v-model="form.highBloodPressureYear"
        label="高血压史/年"
      ></van-field>
      <van-field name="switch" label="糖尿病">
        <template #input>
          <van-switch
            v-model="form.diabetes"
            size="20"
            active-value="是"
            inactive-value="否"
          />
        </template>
      </van-field>
      <van-field name="switch" label="冠心病或支架植入史" label-width="150px"
        ><template #input>
          <van-switch
            v-model="form.coronaryHeartDisease"
            size="20"
            active-value="是"
            inactive-value="否"
          /> </template
      ></van-field>
      <van-field name="switch" label="腹性肥胖"
        ><template #input>
          <van-switch
            v-model="form.bellyFat"
            size="20"
            active-value="是"
            inactive-value="否"
          /> </template
      ></van-field>
      <van-field name="switch" label="眩晕" label-width="30px">
        <template #input>
          <van-radio-group v-model="form.dizziness" direction="horizontal" >
            <van-radio name="从不">从不</van-radio>
            <van-radio name="偶尔">偶尔</van-radio>
            <van-radio name="经常">经常</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="switch" label="胸闷胸痛肩背痛"  label-width="100px"  >
        <template #input>
          <van-radio-group 
            v-model="form.chestDistress"
            direction="horizontal"
          >
            <van-radio name="从不">从不</van-radio>
            <van-radio name="偶尔">偶尔</van-radio>
            <van-radio name="经常">经常</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field name="switch" label="神疲乏力" label-width="60px">
        <template #input>
          <van-radio-group v-model="form.fatigue" direction="horizontal">
            <van-radio name="从不">从不</van-radio>
            <van-radio name="偶尔">偶尔</van-radio>
            <van-radio name="经常">经常</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field name="switch" label="心悸气短自汗"  label-width="90px">
        <template #input>
          <van-radio-group v-model="form.sweat" direction="horizontal">
            <van-radio name="从不">从不</van-radio>
            <van-radio name="偶尔">偶尔</van-radio>
            <van-radio name="经常">经常</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field name="switch" label="家族冠心病">
        <template #input>
          <van-switch
            v-model="form.familyChd"
            size="20"
            active-value="是"
            inactive-value="否"
          />
        </template>
      </van-field>
      <van-field name="switch" label="家族心梗史">
        <template #input>
          <van-switch
            v-model="form.familyMi"
            size="20"
            active-value="是"
            inactive-value="否"
          />
        </template>
      </van-field>
      <van-field name="switch" label="脂肪肝">
        <template #input>
          <van-switch
            v-model="form.fattyLiver"
            size="20"
            active-value="是"
            inactive-value="否"
          />
        </template>
      </van-field>
      <van-field name="switch" label="保健品/药膳">
        <template #input>
          <van-switch
            v-model="form.healthProduct"
            size="20"
            active-value="是"
            inactive-value="否"
            @change="healthProductChange"
          />
        </template>
      </van-field>
      <van-field label="名称：" placeholder="保健品/药膳名称" v-model="form.productName" :disabled="form.healthProduct=='否'"/>

      <van-field
        name="switch"
        label="您是否通过医院检查，明确知道患有某种疾病？"
        label-width="80%"
      >
        <template #input>
          <van-switch
            v-model="form.confirmedDesease"
            size="20"
            active-value="是"
            inactive-value="否"
            @change="confirmedDiseaseChange"
          />
        </template>
      </van-field>
      <van-field label="名称：" placeholder="名称" v-model="form.diseaseName" :disabled="form.confirmedDesease=='否'"/>

      <van-field
        name="switch"
        label="您是否一直坚持服药或其他治疗方法治疗该病？"
        label-width="80%"
      >
        <template #input>
          <van-switch
            v-model="form.longTimeDrug"
            size="20"
            active-value="是"
            inactive-value="否"
            @change="longTimeDrugChange"
          />
        </template>
      </van-field>
      <van-field label="名称：" placeholder="名称" v-model="form.drugName" :disabled="form.longTimeDrug=='否'"/>

      <div style="margin: 16px">
        <van-button type="warning" block native-type="submit" @click="nextStep"
          >下一步</van-button
        >
      </div>
      <!-- <div style="margin: 16px">
        <van-button type="primary" block  @click="skip"
          >跳过</van-button
        >
      </div> -->
    </van-form>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  getUserMedHistory,
  updateUserMedHistory,
} from "../../../api/userService";

export default {
  name: "login",
  data() {
    return {
      teleNum:sessionStorage.getItem('teleNum'),
      form: {
        bellyFat: "否",
        coronaryHeartDisease: "否",
        diabetes: "否",
        familyChd: "否",
        familyMi: "否",
        fattyLiver: "否",
        dizziness: "从不",
        chestDistress: "从不",
        fatigue: "从不",
        sweat: "从不",
        healthProduct: "否",
        productName:"",
        highBloodPressure: "否",
        highBloodPressureYear: "",
        confirmedDesease: "否",
        diseaseName: "",
        longTimeDrug: "否",
        drugName: "",
        userMedHistoryTeleNum: sessionStorage.getItem('teleNum'), //TODO： $store will be emptified when refresh the browser
      },
    };
  },
  // computed: {
  //   teleNum() {
  //     if (this.$store.state.teleNum == "") {
  //       return sessionStorage.getItem("teleNum");
  //     }
  //     return this.$store.state.teleNum;
  //   },
  // },
  // 里面的函数只有调用才会执行
  methods: {
    _getUserMedHistory() {
      //我的诊断中获取 既往病史
      getUserMedHistory(this.teleNum).then((res) => {
        //如果已有用户病史则加载数据库中的信息
        if (res.data[0]) {
          this.form = this.getConverter(res.data[0]);
          //如果已经填写过病史，则可以直接下一步
        }
      });
    },
    //更新用户病史信息
    _updateUserMedHistory() {
      let data = this.postConverter(this.form);
      // console.log("update MedHistory",data)
      // this.$router.push({path:"/appIndex/timeSelect"})
      updateUserMedHistory(JSON.stringify(data))
        .then((res) => {
          if (res.success) {
            // this.$notify({ message: "更新用户既往病史成功", type: "success" });
            //更新用户病史后，进入确认预约界面
            this.$router.push({path:"/appIndex/timeSelect"})
          } else {
            //如果接口调用失败则 告知用户错误信息
            this.$notify({ type: "error", message: res.description });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getConverter(obj) {
      let data = {};
      for (let key in obj) {
        if (key == "highBloodPressure") {
          if (obj[key] != "" && obj[key]!="否") {
            data[key] = "是";
            data["highBloodPressureYear"] = obj[key];
          } else {
            data[key] = "否";
            data["highBloodPressureYear"] = "";
          }
        } else if (key == "longTimeDrug") {
          if (obj[key] != "" && obj[key]!="否") {
             data[key] = "是";
            data["drugName"] = obj[key];
          } else {
            data[key] = "否";
            data["drugName"] = "";
          }
        } else if (key == "confirmedDesease") {
          if (obj[key] != "" && obj[key]!="否") {
               data[key] = "是";
              data["diseaseName"] = obj[key];
            } else {
              data[key] = "否";
              data["diseaseName"] = "";
            }
        } else if (key == "healthProduct") {
          if (obj[key] != "" && obj[key]!="否") {
               data[key] = "是";
              data["productName"] = obj[key];
            } else {
              data[key] = "否";
              data["productName"] = "";
            }
        } else {
          data[key] = obj[key];
        }
      }
      return data;
    },
    postConverter(obj) {
      let data = {};
      for (let key in obj) {
        if (key == "highBloodPressure") {
          if (obj[key] == "是") data[key] = obj["highBloodPressureYear"];
          else data[key] = "否";
        } else if (key == "longTimeDrug") {
          if (obj[key] == "是") data[key] = obj["drugName"];
          else data[key] = "否";
        } else if (key == "confirmedDesease") {
          if (obj[key] == "是") data[key] = obj["diseaseName"];
          else data[key] = "否";
        } else if (key == "healthProduct") {
          if (obj[key] == "是") data[key] = obj["productName"];
          else data[key] = "否";
        } else {
          data[key] = obj[key];
        }
      }
      delete data.highBloodPressureYear;
      delete data.drugName;
      delete data.diseaseName;
      delete data.productName;

      return data;
    },
    highBloodPressureChange(value) {
      if(value=="否") this.form.highBloodPressureYear = ""
    },
    healthProductChange(value) {
      if(value=="否") this.form.productName = ""
    },
    confirmedDiseaseChange(value){
      if(value=="否") this.form.diseaseName = ""
    },
    longTimeDrugChange(value){
      if(value=="否") this.form.drugName = ""
    },
    goback() {
      this.$router.go(-1);
    },
    onClickRight() {},
    nextStep() {
      this._updateUserMedHistory();
      // this.$router.push({ path: "/appIndex/timeSelect" });
    },
    skip(){
      this.$router.push({path:"/appIndex/timeSelect"})
    },
  },
  created() {
    this._getUserMedHistory();
  },
};
</script>

<style scoped>
</style>